import React from "react";
import { Link } from "react-router-dom";
import BusinessLayout from "../../layouts/BusinessLayout";
import OrganizationHomePage from "../../components/organization/OrganizationHomePage";

const BusinessHome: React.FC = () => {
  return (
    <BusinessLayout>
      {(business) => <OrganizationHomePage business={business} LinkComponent={Link} />}
    </BusinessLayout>
  );
};

export default BusinessHome;
